/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SynopsisEvaluationRating } from './SynopsisEvaluationRating';
import {
    SynopsisEvaluationRatingFromJSON,
    SynopsisEvaluationRatingFromJSONTyped,
    SynopsisEvaluationRatingToJSON,
} from './SynopsisEvaluationRating';

/**
 * 
 * @export
 * @interface Report
 */
export interface Report {
    /**
     * 
     * @type {string}
     * @memberof Report
     */
    contactId: string;
    /**
     * 
     * @type {string}
     * @memberof Report
     */
    contactImportId: string;
    /**
     * 
     * @type {string}
     * @memberof Report
     */
    ratingUsername?: string;
    /**
     * 
     * @type {string}
     * @memberof Report
     */
    comment?: string;
    /**
     * 
     * @type {SynopsisEvaluationRating}
     * @memberof Report
     */
    rating?: SynopsisEvaluationRating;
}


/**
 * Check if a given object implements the Report interface.
 */
export function instanceOfReport(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "contactId" in value;
    isInstance = isInstance && "contactImportId" in value;

    return isInstance;
}

export function ReportFromJSON(json: any): Report {
    return ReportFromJSONTyped(json, false);
}

export function ReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): Report {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contactId': json['contactId'],
        'contactImportId': json['contactImportId'],
        'ratingUsername': !exists(json, 'ratingUsername') ? undefined : json['ratingUsername'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'rating': !exists(json, 'rating') ? undefined : SynopsisEvaluationRatingFromJSON(json['rating']),
    };
}

export function ReportToJSON(value?: Report | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contactId': value.contactId,
        'contactImportId': value.contactImportId,
        'ratingUsername': value.ratingUsername,
        'comment': value.comment,
        'rating': SynopsisEvaluationRatingToJSON(value.rating),
    };
}

